export default {
  NEW_DESIGN: {
    BOX_SHADOW: '0 10px 10px rgba(0,0,0,0.1)',
  },
};
